
<row class="el-item propagate-drag col-md-12">
  <prefix>
    <input
      :id="model.idForProp('label_title')"
      type="checkbox"
      disabled
    >
  </prefix>
  <property-change-detector
    :left="model"
    :right="model.publishedEquivalent"
    :properties="[['label_title', 'label']]"
    tag="prefix"
  />
  <column>
    <object-model-property-labelable
      ref="itemComponent"
      :object-model-property="model"
      :placeholder="placeholder"
      v-on:paste="handlePaste"
      v-on:blur="blur"
      v-on:keydown:enter="enter"></object-model-property-labelable>
  </column>
  <suffix>
    <dynamic-child-context-menu
      :model="model"
      v-on:remove="tryRemove"
    ></dynamic-child-context-menu>
  </suffix>

  <confirmation-modal
    v-if="modalStateFor(vueModalID.confirmChange).isVisible"
    :state="modalStateFor(vueModalID.confirmChange)"
    :override-config="confirmationConfig"
    @toggle-modal="handleConfirmation"
  />
</row>
